// extracted by mini-css-extract-plugin
module.exports = {"root":"button-icon_root__aHv9s"};